import { render, staticRenderFns } from "./ItecDish.vue?vue&type=template&id=227b1b56"
import script from "./ItecDish.vue?vue&type=script&lang=ts"
export * from "./ItecDish.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports